module.exports = __webpack_public_path__ + "img/pic2.205e32a1.png";